import { useMsal } from "@azure/msal-react";
import { getAccountRoles, userHasRequiredRole } from "./utils/authUtils";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Alert, Box, Typography } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "dark",
  },
});
const ProtectedRoute = ({ component: Component, requiredRole, ...rest }) => {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const roles = getAccountRoles(account);
  const requiredRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];

  if (!account) {
    return null;
  }

  if (!userHasRequiredRole(account, requiredRoles)) {
    return (
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", maxWidth: 900, p: 4, color: "white" }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            You are signed in, but your account does not have access to this page.
          </Alert>
          <Typography variant="body1">
            Required role: {requiredRoles.join(" or ")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Your roles: {roles.length ? roles.join(", ") : "none found in token"}
          </Typography>
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Component {...rest} />
    </ThemeProvider>
  );
};

export default ProtectedRoute;
